// extracted by mini-css-extract-plugin
export var actionButton = "_j2-0";
export var fileInput = "_j2-2";
export var paperclip = "_j2-1";